export type AnyRecord = Record<string, unknown>

/* ------------------------------------------------------------------ *
 * Tolerant reads
 * ------------------------------------------------------------------ */

export function asRecord(value: unknown): AnyRecord | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null
  return value as AnyRecord
}

/**
 * Checkpoint metadata arrives in mixed casing (`nsDocument` / `NsDocument`) while protobuf decode
 * yields camelCase and the raw JSON API path can yield snake_case - the same three-way tolerance
 * `read-wire-shape-paint.ts` and `checkpoint-to-shapes.ts` already apply.
 */
export function pick(record: AnyRecord | null, name: string): unknown {
  if (!record) return undefined
  if (name in record) return record[name]

  const pascal = name.charAt(0).toUpperCase() + name.slice(1)

  if (pascal in record) return record[pascal]

  const snake = name.replace(/[A-Z]/g, (c) => `_${c.toLowerCase()}`)

  return snake in record ? record[snake] : undefined
}

export function pickRecord(record: AnyRecord | null, name: string): AnyRecord | null {
  return asRecord(pick(record, name))
}

export function pickArray(record: AnyRecord | null, name: string): unknown[] {
  const value = pick(record, name)

  return Array.isArray(value) ? value : []
}
